import { Link } from 'react-router-dom';
import CustomNavbar from '../components/Navbar';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import { PAGE_SEO } from '../seo/pages';

function NotFoundPage() {
  const seo = PAGE_SEO.notFound;

  return (
    <div className="not-found-page">
      <Seo title={seo.title} description={seo.description} noindex />
      <CustomNavbar />
      <section
        className="not-found-page__banner"
        style={{ backgroundImage: "url('/images/new-banner-new.png')" }}
      >
        <h1>Page not found</h1>
      </section>
      <section className="not-found-page__body">
        <p>
          This address is not a current Q-Gold page. It may be from an older version of
          the site, or the link may be incomplete.
        </p>
        <nav className="not-found-page__links" aria-label="Helpful pages">
          <Link to="/">Home</Link>
          <Link to="/news">News</Link>
          <Link to="/investors">Investors</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </section>
      <Footer />
    </div>
  );
}

export default NotFoundPage;
